import { authMiddleware } from "@/middleware";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { DashboardLayout } from "@/components";
import SenderPage from "@/pages/senders/Senders";
import { currentUserAtom } from "@/store/login";
import { useAtomValue } from "jotai";
import { z } from "zod";

const SearchSchema = z.object({
	page: z.coerce.number().int().min(1).default(1),
	pageSize: z.coerce.number().int().min(5).max(200).default(25),

	email: z.string().trim().optional().default(""),
	statuses: z
		.union([z.string(), z.array(z.string())])
		.transform((v) => (typeof v === "string" ? [v] : v ?? []))
		.default([]),
	groups: z
		.union([z.string(), z.array(z.string())])
		.transform((v) => (typeof v === "string" ? [v] : v ?? []))
		.default([]),
	/** Admin only: senders of one user */
	owner: z.string().optional().default(""),
	priority: z
		.union([z.string(), z.array(z.string())])
		.transform((v) => (typeof v === "string" ? [v] : v ?? []))
		.default([]),
	cooldown: z.enum(["", "active", "ready"]).optional().default("").catch(""),
});

export type SendersSearch = z.infer<typeof SearchSchema>;

export const Route = createFileRoute("/_market/senders/")({
	validateSearch: zodValidator(SearchSchema),
	component: () => {
		const userRole = useAtomValue(currentUserAtom)?.user_role;
		const isAdmin = userRole === "ADMIN";

		return (
			<DashboardLayout>
				<SenderPage isAdmin={isAdmin} />
			</DashboardLayout>
		);
	},
	loader: authMiddleware,
});
